// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/list_my_blocked_accounts.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/list_my_blocked_accounts.proto.
 */
export const file_accounts_list_my_blocked_accounts: GenFile = /*@__PURE__*/
  fileDesc("CidhY2NvdW50cy9saXN0X215X2Jsb2NrZWRfYWNjb3VudHMucHJvdG8SD3Byb3Rvcy5hY2NvdW50cyLxAQocTGlzdE15QmxvY2tlZEFjY291bnRzUmVxdWVzdBJECgZwYXJhbXMYASABKAsyNC5wcm90b3MuYWNjb3VudHMuTGlzdE15QmxvY2tlZEFjY291bnRzUmVxdWVzdC5QYXJhbXMSTAoKcGFnaW5hdGlvbhgCIAEoCzI4LnByb3Rvcy5hY2NvdW50cy5MaXN0TXlCbG9ja2VkQWNjb3VudHNSZXF1ZXN0LlBhZ2luYXRpb24aCAoGUGFyYW1zGjMKClBhZ2luYXRpb24SEgoKcGFnZV90b2tlbhgBIAEoCRIRCglwYWdlX3NpemUYAiABKAUipgMKHUxpc3RNeUJsb2NrZWRBY2NvdW50c1Jlc3BvbnNlEkUKBnJlc3VsdBgBIAEoCzI1LnByb3Rvcy5hY2NvdW50cy5MaXN0TXlCbG9ja2VkQWNjb3VudHNSZXNwb25zZS5SZXN1bHQSTQoKcGFnaW5hdGlvbhgCIAEoCzI5LnByb3Rvcy5hY2NvdW50cy5MaXN0TXlCbG9ja2VkQWNjb3VudHNSZXNwb25zZS5QYWdpbmF0aW9uGscBCgZSZXN1bHQSTwoIYWNjb3VudHMYASADKAsyPS5wcm90b3MuYWNjb3VudHMuTGlzdE15QmxvY2tlZEFjY291bnRzUmVzcG9uc2UuUmVzdWx0LkFjY291bnQabAoHQWNjb3VudBISCgphY2NvdW50X2lkGAEgASgJEgwKBG5hbWUYAiABKAkSDwoHcGZwX3VybBgDIAEoCRIuCgpibG9ja2VkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBolCgpQYWdpbmF0aW9uEhcKD25leHRfcGFnZV90b2tlbhgBIAEoCWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.accounts.ListMyBlockedAccountsRequest
 */
export type ListMyBlockedAccountsRequest = Message<"protos.accounts.ListMyBlockedAccountsRequest"> & {
  /**
   * @generated from field: protos.accounts.ListMyBlockedAccountsRequest.Params params = 1;
   */
  params?: ListMyBlockedAccountsRequest_Params | undefined;

  /**
   * @generated from field: protos.accounts.ListMyBlockedAccountsRequest.Pagination pagination = 2;
   */
  pagination?: ListMyBlockedAccountsRequest_Pagination | undefined;
};

/**
 * Describes the message protos.accounts.ListMyBlockedAccountsRequest.
 * Use `create(ListMyBlockedAccountsRequestSchema)` to create a new message.
 */
export const ListMyBlockedAccountsRequestSchema: GenMessage<ListMyBlockedAccountsRequest> = /*@__PURE__*/
  messageDesc(file_accounts_list_my_blocked_accounts, 0);

/**
 * @generated from message protos.accounts.ListMyBlockedAccountsRequest.Params
 */
export type ListMyBlockedAccountsRequest_Params = Message<"protos.accounts.ListMyBlockedAccountsRequest.Params"> & {
};

/**
 * Describes the message protos.accounts.ListMyBlockedAccountsRequest.Params.
 * Use `create(ListMyBlockedAccountsRequest_ParamsSchema)` to create a new message.
 */
export const ListMyBlockedAccountsRequest_ParamsSchema: GenMessage<ListMyBlockedAccountsRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_list_my_blocked_accounts, 0, 0);

/**
 * @generated from message protos.accounts.ListMyBlockedAccountsRequest.Pagination
 */
export type ListMyBlockedAccountsRequest_Pagination = Message<"protos.accounts.ListMyBlockedAccountsRequest.Pagination"> & {
  /**
   * @generated from field: string page_token = 1;
   */
  pageToken: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message protos.accounts.ListMyBlockedAccountsRequest.Pagination.
 * Use `create(ListMyBlockedAccountsRequest_PaginationSchema)` to create a new message.
 */
export const ListMyBlockedAccountsRequest_PaginationSchema: GenMessage<ListMyBlockedAccountsRequest_Pagination> = /*@__PURE__*/
  messageDesc(file_accounts_list_my_blocked_accounts, 0, 1);

/**
 * @generated from message protos.accounts.ListMyBlockedAccountsResponse
 */
export type ListMyBlockedAccountsResponse = Message<"protos.accounts.ListMyBlockedAccountsResponse"> & {
  /**
   * @generated from field: protos.accounts.ListMyBlockedAccountsResponse.Result result = 1;
   */
  result?: ListMyBlockedAccountsResponse_Result | undefined;

  /**
   * @generated from field: protos.accounts.ListMyBlockedAccountsResponse.Pagination pagination = 2;
   */
  pagination?: ListMyBlockedAccountsResponse_Pagination | undefined;
};

/**
 * Describes the message protos.accounts.ListMyBlockedAccountsResponse.
 * Use `create(ListMyBlockedAccountsResponseSchema)` to create a new message.
 */
export const ListMyBlockedAccountsResponseSchema: GenMessage<ListMyBlockedAccountsResponse> = /*@__PURE__*/
  messageDesc(file_accounts_list_my_blocked_accounts, 1);

/**
 * @generated from message protos.accounts.ListMyBlockedAccountsResponse.Result
 */
export type ListMyBlockedAccountsResponse_Result = Message<"protos.accounts.ListMyBlockedAccountsResponse.Result"> & {
  /**
   * @generated from field: repeated protos.accounts.ListMyBlockedAccountsResponse.Result.Account accounts = 1;
   */
  accounts: ListMyBlockedAccountsResponse_Result_Account[];
};

/**
 * Describes the message protos.accounts.ListMyBlockedAccountsResponse.Result.
 * Use `create(ListMyBlockedAccountsResponse_ResultSchema)` to create a new message.
 */
export const ListMyBlockedAccountsResponse_ResultSchema: GenMessage<ListMyBlockedAccountsResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_list_my_blocked_accounts, 1, 0);

/**
 * @generated from message protos.accounts.ListMyBlockedAccountsResponse.Result.Account
 */
export type ListMyBlockedAccountsResponse_Result_Account = Message<"protos.accounts.ListMyBlockedAccountsResponse.Result.Account"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string pfp_url = 3;
   */
  pfpUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp blocked_at = 4;
   */
  blockedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.accounts.ListMyBlockedAccountsResponse.Result.Account.
 * Use `create(ListMyBlockedAccountsResponse_Result_AccountSchema)` to create a new message.
 */
export const ListMyBlockedAccountsResponse_Result_AccountSchema: GenMessage<ListMyBlockedAccountsResponse_Result_Account> = /*@__PURE__*/
  messageDesc(file_accounts_list_my_blocked_accounts, 1, 0, 0);

/**
 * @generated from message protos.accounts.ListMyBlockedAccountsResponse.Pagination
 */
export type ListMyBlockedAccountsResponse_Pagination = Message<"protos.accounts.ListMyBlockedAccountsResponse.Pagination"> & {
  /**
   * @generated from field: string next_page_token = 1;
   */
  nextPageToken: string;
};

/**
 * Describes the message protos.accounts.ListMyBlockedAccountsResponse.Pagination.
 * Use `create(ListMyBlockedAccountsResponse_PaginationSchema)` to create a new message.
 */
export const ListMyBlockedAccountsResponse_PaginationSchema: GenMessage<ListMyBlockedAccountsResponse_Pagination> = /*@__PURE__*/
  messageDesc(file_accounts_list_my_blocked_accounts, 1, 1);

